import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallCampaignRibbonImage } from '../../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallCampaignRibbonProps } from './PrizeWallCampaignRibbon.types';
import PrizeWallImage from '../common/PrizeWallImage/PrizeWallImage';

function PrizeWallCampaignRibbon(props: PrizeWallCampaignRibbonProps) {
  const ribbonImage = useSelector(selectPrizeWallCampaignRibbonImage);

  return (
    <PrizeWallImage
      width="100%"
      height="space-1200"
      {...ribbonImage}
      {...props}
    />
  );
}

export default memo(PrizeWallCampaignRibbon);
